export default __webpack_public_path__ + "static/media/frame1.9417c662.webp";